const modules = {};

// Rearchitected
const rearchitected = new (require('@core/js/store/rearchitected/store.ts').default)();
modules.rearchitected = rearchitected;

modules.globalDictionaries = require('./globalDictionaries.js').default;

export default modules;
